const projectId = 'careerscope-dev';

export const environment = {
  production: false,
  useEmulators: false,
  dev: false,
  vx: false,
  firebase: {
    apiKey: "AIzaSyCvkpWgRB1yoe0OdeMYNrizn1R5F061tpI",
    authDomain: "careerscope-dev.firebaseapp.com",
    projectId,
    storageBucket: "careerscope-dev.appspot.com",
    messagingSenderId: "744158600910",
    appId: "1:744158600910:web:a1afadcc30906db91bfa9f"
  },
  storageBucket: 'careerscope-dev.appspot.com',
  evalueeInvitationURL: 'https://app-staging.careerscope.com/login/',
  evalueeUsernameURL: 'https://app-staging.careerscope.com/username/',
  managerInvitationURL: 'https://admin-staging.careerscope.com/login/',
  portalInvitationURL: 'https://app-staging.careerscope.com/portal/',
  functionsURL: 'https://us-central1-careerscope-dev.cloudfunctions.net',
  stripePublishableKey: 'pk_live_VFK44AR1F0c0HEyGM1GBhUsd00RhbACPqJ'
};
